import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero/Hero';
import ImportServices from '../components/ImportServices/ImportServices';
import ExportServices from '../components/ExportServices/ExportServices';
import ContactForm from '../components/ContactForm/ContactForm';
import WorkProcess from '../components/WorkProcess/WorkProcess';
import WhyUs from '../components/WhyUs/WhyUs';
import Stats from '../components/Stats/Stats';
import Team from '../components/Team/Team';

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Советник — Импорт и экспорт под ключ | Сопровождение ВЭД</title>
        <meta name="description" content="Импорт и экспорт под ключ — без рисков и задержек. Таможенное оформление, логистика, сертификация, валютный контроль. 20+ лет опыта в ВЭД: Европа, Турция, Китай, Индия, Вьетнам. Бесплатная консультация." />
        <meta name="keywords" content="ВЭД, импорт, экспорт, таможенное оформление, юридическое сопровождение, валютный контроль, сертификация, международная торговля, Тверь, консультант, советник" />
        <link rel="canonical" href="https://konsultant-sovetnik.ru/" />
        <meta property="og:title" content="Советник — Импорт и экспорт под ключ" />
        <meta property="og:description" content="Берём на себя таможню, логистику, сертификацию и валютный контроль. Вы получаете товар или экспортную выручку — без бюрократии." />
        <meta property="og:url" content="https://konsultant-sovetnik.ru/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://konsultant-sovetnik.ru/logo512.png" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "ООО Советник",
          "legalName": "Общество с ограниченной ответственностью «Советник»",
          "url": "https://konsultant-sovetnik.ru/",
          "logo": "https://konsultant-sovetnik.ru/logo512.png",
          "description": "Юридическое и логистическое сопровождение импорта и экспорта. Таможенное оформление, сертификация, валютный контроль.",
          "email": "info@konsultant-sovetnik.ru",
          "telephone": "+7-910-936-98-89",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "пер. Спортивный, д.1А, оф.9",
            "addressLocality": "Тверь",
            "addressCountry": "RU"
          },
          "sameAs": []
        })}</script>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          "name": "ООО Советник — Сопровождение ВЭД",
          "image": "https://konsultant-sovetnik.ru/logo512.png",
          "url": "https://konsultant-sovetnik.ru/",
          "telephone": "+7-910-936-98-89",
          "priceRange": "₽₽",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "пер. Спортивный, д.1А, оф.9",
            "addressLocality": "Тверь",
            "addressCountry": "RU"
          },
          "areaServed": ["Россия", "Европа", "Турция", "Китай", "Индия", "Вьетнам"],
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "18:00"
          }
        })}</script>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "ООО Советник",
          "url": "https://konsultant-sovetnik.ru/",
          "inLanguage": "ru-RU"
        })}</script>
      </Helmet>
      <Hero />
      <ImportServices />
      <ExportServices />
      <ContactForm type="consultation" />
      <WorkProcess />
      <WhyUs />
      <Stats />
      <Team />
      <ContactForm type="calculation" />
    </>
  );
}
